import { useAppSelector } from 'stores/Hooks'
import { getGlobalLoading } from 'stores/MovieSlice'

const GlobalSpinner = () => {
  const isLoading = useAppSelector(getGlobalLoading)

  if (!isLoading) return null

  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm'>
      <div className='flex flex-col items-center gap-4'>
        {/* Spinner */}
        <div className='relative h-16 w-16'>
          <div className='absolute inset-0 rounded-full border-4 border-gray-700'></div>
          <div className='absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-blue-500 border-r-blue-400'></div>
        </div>

        {/* Loading text */}
        <p className='text-lg font-medium text-white'></p>
      </div>
    </div>
  )
}

export default GlobalSpinner
